import React from 'react'
import { useTranslation } from 'react-i18next'

import { ParticipantUser } from 'src/pages/Bottle/Bottles.types'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import { CustomButton } from '../CustomButton/CustomButton'
import styles from './BottleParticipants.module.scss'
import { ParticipantsList } from './components/ParticipantsList/ParticipantsList'
import { useShowSearchButton } from './hooks/useShowSearchButton'

export const BottleParticipants = ({
  typeOfBottle,
  total_stars,
  total_tickets,
  participantsList,
  className,
  variant,
}: {
  typeOfBottle: 'ANY' | 'FIXED' | 'CHARITABLE' | undefined
  total_stars: number
  total_tickets: number
  participantsList: ParticipantUser[] | undefined
  className?: string
  variant?: 'list' | 'bottle'
}) => {
  const { t } = useTranslation()

  const myName = useGlobalStore((store) => store.user?.username)
  const targetElementRef = React.useRef<HTMLDivElement | null>(null)
  let indexForMyElement = participantsList?.findIndex((participant) => participant.user.username === myName) || -1

  const { isElementVisible } = useShowSearchButton(indexForMyElement, targetElementRef)

  participantsList = participantsList?.sort((a, b) => {
    const aTotalTickets = a.stars_amount * 20 + a.tickets
    const bTotalTickets = b.stars_amount * 20 + b.tickets

    return bTotalTickets - aTotalTickets
  })

  let newFormattedParticipants = []

  if (variant === 'bottle' && participantsList) {
    if (indexForMyElement > -1) {
      newFormattedParticipants = [...participantsList.slice(0, 2)]

      if (participantsList[indexForMyElement] === undefined) {
        newFormattedParticipants.push(participantsList[indexForMyElement])
      } else {
        newFormattedParticipants = [...participantsList.slice(0, 3)]
      }
    } else {
      newFormattedParticipants = [...participantsList.slice(0, 3)]
    }
  }

  return (
    <div className={styles.participants}>
      <div className={`${styles.participants_title} ${className}`}>
        <p>№</p>
        <p>{t('participants.nickname_of_user')}</p>
        <p>{t('participants.tickets_and_chance')}</p>
      </div>

      <div className={styles.participants_list}>
        <ParticipantsList
          styles={styles}
          participantsList={participantsList}
          typeOfBottle={typeOfBottle}
          total_stars={total_stars}
          total_tickets={total_tickets}
          variant={variant}
          targetElementRef={targetElementRef}
        />

        {!isElementVisible && variant === 'list' && indexForMyElement > -1 && (
          <CustomButton
            className={styles.button}
            variant='contained'
            color='violet'
            onClick={() => targetElementRef.current?.scrollIntoView({ behavior: 'smooth' })}
          >
            {t('participants.show_me')}
          </CustomButton>
        )}
      </div>
    </div>
  )
}
